import React from 'react';

const CircleDollarIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_26647_125302)">
      <path
        d="M10.0013 18.3346C14.6037 18.3346 18.3346 14.6037 18.3346 10.0013C18.3346 5.39893 14.6037 1.66797 10.0013 1.66797C5.39893 1.66797 1.66797 5.39893 1.66797 10.0013C1.66797 14.6037 5.39893 18.3346 10.0013 18.3346Z"
        stroke="#616893"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.3346 6.66797H8.33464C7.89261 6.66797 7.46869 6.84356 7.15612 7.15612C6.84356 7.46869 6.66797 7.89261 6.66797 8.33464C6.66797 8.77666 6.84356 9.20059 7.15612 9.51315C7.46869 9.82571 7.89261 10.0013 8.33464 10.0013H11.668C12.11 10.0013 12.5339 10.1769 12.8465 10.4895C13.159 10.802 13.3346 11.2259 13.3346 11.668C13.3346 12.11 13.159 12.5339 12.8465 12.8465C12.5339 13.159 12.11 13.3346 11.668 13.3346H6.66797"
        stroke="#616893"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 15V5"
        stroke="#616893"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_26647_125302">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default CircleDollarIcon;
